<template>
    <div class="mp_list">
        <div v-if="hasSubscribe()" class="sub_wrap">
            <div class="sub_name">{{ memberData.MemberSubscribe.TermsInfo.o_name }}</div>
            <div class="sub_status">{{returnSubStatus()}}</div>
            <div class="sub_date">~ {{returnDateUnix(memberData.MemberSubscribe.TermsInfo.st_subscribe_date, 'YYYY-MM-DD')}}</div>
        </div>
        <div v-else>
            구독중인 상품이 없습니다.
        </div>
    </div>
</template>

<script>
import alertMixins from "@/mixins/alertMixins";
import util from "@/mixins/util";
import dateMixins from "@/mixins/dateMixins";

export default {
    name: "MemberCheckPremiumComponent",
    mixins: [alertMixins, dateMixins],
    components: {},
    provide() {
        return {}
    },
    inject: ['changeLoading'],
    props: {
        memberKey: ''
    },
    data() {
        return {
            memberData: {},
        }
    },
    created() {
        if (!util.isEmpty(this.memberKey)) {
            this.getMember()
        }
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        getMember() {
            let params = {
                mt: "student",
                sub: 1,
                no: this.memberKey,
                ss: 1
            }
            try {
                this.$api.$member.getMember(params).then(result => result.Data.Result).then(res => {
                    if (res.Info.type !== 1) {
                        this.errorAlert('회원정보를 불러올 수 없습니다.')
                    } else {
                        this.memberData = res.List[0]
                    }
                })
            } catch (e) {

            }
        },
        hasSubscribe(){
            return !util.isEmpty(this.memberData.MemberSubscribe)
        },
        returnSubStatus(){
            if(this.hasSubscribe()){
                let status = this.memberData.MemberSubscribe.TermsInfo.st_status
                switch (status){
                    case 0:
                        return '대기'
                    case 1:
                        return '구독중'
                    case 2:
                        return '완료'
                    case 3:
                        return '스킵'
                    default:
                        return ''
                }
            }
        }


    },
    watch: {},
}
</script>

<style scoped>

</style>
